import { Layout } from "react-grid-layout";

export const DashboardUserDataItem_Count = "UserDataItem_Count";
export const DashboardUserDataItem_Pie = "UserDataItem_Pie";
export const DashboardUserDataItem_Latest = "UserDataItem_Latest";
export const DashboardUnityDataItem_Count = "UnityDataItem_Count";
export const DashboardUnityDataItem_Pie = "UnityDataItem_Pie";
export const DashboardAttendanceDataItem_Today = "AttendanceDataItem_Today";
export const DashboardAttendanceDataItem_Yesterday =
  "AttendanceDataItem_Yesterday";
export const DashboardAttendanceDataItem_Latest = "AttendanceDataItem_Latest";
export const DashboardPatrolDataItem_Today = "PatrolDataItem_Today";
export const DashboardVisitDataItem_Today = "VisitDataItem_Today";
export const DashboardVehicleDataItem_Today = "VehicleDataItem_Today";
export const DashboardGoodsDataItem_Today = "GoodsDataItem_Today";
export const DashboardPatrolDataItem_Yesterday = "PatrolDataItem_Yesterday";
export const DashboardPatrolDataItem_Latest = "PatrolDataItem_Latest";
export const DashboardIncidentDataItem_Today = "IncidentDataItem_Today";
export const DashboardIncidentDataItem_Yesterday = "IncidentDataItem_Yesterday";
export const DashboardIncidentDataItem_Latest = "IncidentDataItem_Latest";
export const DashboardErrorLogsItem = "ErrorLogsItem";
export const DashboardEventListItem = "EventListItem";

export const DashboardMainLayoutSmall_1: Layout[] = [
  { w: 1, h: 12, x: 0, y: 0, i: DashboardUserDataItem_Count, static: false },

  { w: 1, h: 12, x: 0, y: 12, i: DashboardUserDataItem_Latest, static: false },

  { w: 1, h: 12, x: 0, y: 24, i: DashboardUnityDataItem_Pie, static: false },
  { w: 1, h: 12, x: 0, y: 36, i: DashboardVisitDataItem_Today, static: false },
  {
    w: 1,
    h: 12,
    x: 0,
    y: 48,
    i: DashboardVehicleDataItem_Today,
    static: false,
  },
];

export const DashboardMainLayoutMedium_2: Layout[] = [
  { w: 1, h: 12, x: 0, y: 0, i: DashboardUserDataItem_Count, static: false },

  { w: 1, h: 12, x: 1, y: 0, i: DashboardUserDataItem_Latest, static: false },

  { w: 1, h: 12, x: 0, y: 12, i: DashboardUnityDataItem_Pie, static: false },
  { w: 1, h: 12, x: 1, y: 12, i: DashboardVisitDataItem_Today, static: false },
  {
    w: 1,
    h: 12,
    x: 0,
    y: 24,
    i: DashboardVehicleDataItem_Today,
    static: false,
  },
];

export const DashboardMainLayoutLarge_3: Layout[] = [
  { w: 1, h: 12, x: 0, y: 0, i: DashboardUserDataItem_Count, static: false },

  { w: 1, h: 12, x: 1, y: 0, i: DashboardUserDataItem_Latest, static: false },

  { w: 1, h: 12, x: 2, y: 0, i: DashboardUnityDataItem_Pie, static: false },
  { w: 1, h: 12, x: 0, y: 12, i: DashboardVisitDataItem_Today, static: false },
  {
    w: 1,
    h: 12,
    x: 1,
    y: 12,
    i: DashboardVehicleDataItem_Today,
    static: false,
  },
];

export const DashboardMainLayoutXLarge_4: Layout[] = [
  { w: 1, h: 12, x: 0, y: 0, i: DashboardUserDataItem_Count, static: false },

  { w: 1, h: 12, x: 1, y: 0, i: DashboardUserDataItem_Latest, static: false },

  { w: 1, h: 12, x: 2, y: 0, i: DashboardUnityDataItem_Pie, static: false },
  { w: 1, h: 12, x: 0, y: 12, i: DashboardVisitDataItem_Today, static: false },
  {
    w: 1,
    h: 12,
    x: 1,
    y: 12,
    i: DashboardVehicleDataItem_Today,
    static: false,
  },
];
